export interface ITableSelected {
    getSelectedItems: () => any[];
    hideContextRibbon: () => any[];
    getData: () => any[];
}
export interface IPattern {
    data: any[],
    cols: any[],
    name: string;
}
export interface IPaternList {
    label: string,
    value: string | any[];
}
export interface IPartyData {
    country: string;
    company: string;
    organization: string;
    vendorsData: any[];
}
export interface IProps {
    link: (url: string) => void;
    organisation: IPaternList[],
    locations: IPaternList[],
    cargoDetails: IPaternList[],
    jobIdDetails: IPaternList[],
    equipments: IPattern,
    bookings: IPattern,
    cbl: IPattern,
    clr: IPattern,
    equipmentTransportShipments: IPattern,
    voyages: IPattern,
    customerInvoice: IPattern,
    isExtraDocumentFeatureEnabled: boolean;
}
export interface IETSProps {
    link: (url: string) => void;
    organisation: IPaternList[],
    locations: IPaternList[],
    cargoDetails: IPaternList[],
    shipmentDetails: IPaternList[],
    booking: IPattern,
    cbl: IPattern,
    equipments: IPattern,
    fcr: IPattern,
    equipmentTransportShipments: IPaternList[],
    voyages: IPattern,
    customerInvoice: IPattern,
    isExtraDocumentFeatureEnabled: boolean;
}
export interface IBProps {
    organisation: IPaternList[],
    locations: IPaternList[],
    cargoDetails: IPaternList[],
    jobIdDetails: IPaternList[],
    equipments: IPattern,
    cbl: IPattern,
    clr: IPattern,
    fcr: IPattern,
    link: (str: string) => void,
    isExtraDocumentFeatureEnabled: boolean,
}

export enum FinOpsStatus {
    open = 'Open',
    rateReceived = 'Rate Received',
    received = 'Received',
    salesOrderCreated = 'Sales Order Created',
    salesOrderUpdated = 'Sales Order Updated',
    rateRequested = 'Rate Requested',
    salesOrderRequested = 'Sales Order Requested',
    salesOrderCreateRequested = 'Sales Order Create Requested',
    salesOrderUpdateRequested = 'Sales Order Update Requested',
    invoiceRequested = 'Invoice Requested',
    salesOrderCancelRequested = 'Sales Order Cancel Requested',
    invoiceCancellationRequested = 'Invoice Cancellation Requested',
    invoiceInFinopsCreated = 'Invoice in FinOps Created',
    partialInvoiced = 'Partial Invoiced',
    fullInvoiced = 'Full Invoiced',
    partialSettled = 'Partial Settled',
    fullSettled = 'Full Settled',
    rejected = 'Sales Order Rejected',
    invoiceInFinopsCreatedLowerCase = 'invoice in finops created',
}

export enum chargeStatus {
    linkedFinalInvoice = 'Linked to Final Invoice',
    linkedPartialSupplierInvoice = 'Linked to Partial Supplier Invoice',
    linkedSupplierInvoice = 'Linked to Supplier Invoice',
    linkedSalesOrder = 'Linked to Sales Order',
}

export enum costAndRevErrorMessage {
    SIMPLE_ERROR = 'Field is required',
    errorMsgRev = 'Bill to Party Not Allowed to change between IC and Non-IC',
    errorMsgQuantity = 'Quantity must be numeric and not exceed 6 characters and 3 decimals',
    errorMsgQuantityNew = 'Quantity should not exceed 3 digit if UOM is DOC or CNT or EA or PAL',
    errorMsgCost = 'Pay to Party Not Allowed to change between IC and Non-IC',
    validationMsgCostandRev = 'Not Allowed to change between IC and Non - IC',
    validationMsgReasonCode = 'Field is Required (One of the charge line have missing Reason Code)',
    validationMsgVatPartnerEditReasonCode = 'Field is Required (One of the charge line have missing Vat Partner Edit Reason Code)',
    noExportJobAvailable = 'There are no valid jobs associated with this record to distribute charges to. Adding charge item not possible.',    
    zeroPriceError = 'For the 0 priced charge line(s), please update it to a non-zero value for the price or delete them, so to get the Sales Order updated in SAP',
    errorMsgInternalReferenceNumber = 'IRN must be alphanumeric',
    errorMsgInternalReferenceNumberLength = 'IRN must not exceed 100 characters',
}